<template>
  <div style="width:100%">
    <Loading :value="loading"></Loading>

    <v-layout row>
      <div align="center">
        <v-chip
          text-color="white"
          label
          color="primary"
          style="width: 100%; font-weight:bold; font-size: 25px"
        >VEUILLEZ EFFECTUER VOTRE RECHERCHE EN FONCTION DU PROJET OU DES CHANTIERS</v-chip>
        <!-- </div>
        <div class="grid-content" style="padding:3px; margin:5px">-->
        <el-row>
          <v-container fluid grid-list-md>
            <el-card class="box-card">
              <v-form
               
              >
                <v-layout row v-if="droitAcces.work_All_projet">
                  <v-flex md3> 
                    <el-select
                        v-model="selectTypeSearchProjet"
                        placeholder="Projet"
                        style="width:100%"
                         v-on:change="loadTravauxSuiviProjet(selectTypeSearchProjet)"
                    >
                        <el-option
                        v-for="item in listProjet"
                        :key="item.id"
                        :label="item.libelle"
                        :value="item.id"
                        ></el-option>
                    </el-select>
                  </v-flex>
                  <v-flex md4>
                    <el-select
                      clearable
                     
                      v-model="selectSearchChantierSuivi"
                      placeholder="Chantier"
                      style="width:100%"
                    >
                      <el-option
                        v-for="item in listChantier"
                        :key="item.id"
                        :label="item.libelle"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </v-flex>

                  <v-flex md1 v-if="selectSearchChantierSuivi != ''">
                    <v-btn icons color="blue" @click="loadChantierDetails(selectSearchChantierSuivi)" fab dark small>
                      <v-icon>search</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-form>
            </el-card>
          </v-container>
        </el-row>
      </div>
    </v-layout>
    <!--Listes des Chantiers-->
    <v-layout row>
      <v-flex md12>
        <v-layout row>
          <v-card style="width:100%">
            <v-card-text fluid grid-list-md>
              <h4>LISTE DES WORKLOGS</h4>
              <div class="text-xs-right">
                <!-- <v-tooltip top >
                                <v-btn  slot="activator" color="green" :disabled="disabledBtnMiss" @click.stop="imprimeMissionExc(selectEtatMiss)" dark>
                                    Liste en Excel
                                    <v-icon right > print</v-icon>
                                </v-btn>
                                Imprimer la liste des missions
                </v-tooltip>-->

                <!-- <v-tooltip top  >
                                <v-btn slot="activator" color="orange" :disabled="disabledBtnMiss" @click.stop="imprimeChantier(selectEtatMiss)" dark>
                                    Liste
                                    <v-icon right > print</v-icon>
                                </v-btn>
                                Imprimer la liste des missions
                </v-tooltip>-->
                <!--Bouton ajouter Mission-->
              </div>
              <v-divider></v-divider>

              <v-layout row class="mb-2 mt-2" v-if="droitAcces.work_All_projet">
                <v-flex xs4>
                  <v-chip color="cyan" text-color="white">
                    <v-avatar class="cyan darken-4">{{worklogTotal}}</v-avatar>WORKLOGS
                  </v-chip>
                </v-flex>

                <v-flex xs4>
                  <v-chip color="cyan" text-color="white">
                    <v-avatar class="cyan darken-4">{{totalActivite}}</v-avatar> ACTIVITE(S)
                  </v-chip>
                </v-flex>

                <v-flex xs4>
                  <v-chip color="blue" text-color="white">
                    <v-avatar class="cyan darken-4">{{totalActiviteEncours}}</v-avatar> ACTIVITE(S) EN COURS
                  </v-chip>
                </v-flex>

                <v-flex xs4>
                  <v-chip color="green" text-color="white">
                    <v-avatar class="cyan darken-4">{{totalActiviteTermine}}</v-avatar> ACTIVITE(S) TERMINEE(S)
                  </v-chip>
                </v-flex>
              </v-layout>

              <v-layout row>
                <v-flex sm12>
                  <data-tables :data="listeWorklog" :resizable="false" v-if="droitAcces.work_All_projet">
                    <el-table-column prop="projet" label="PROJET" > </el-table-column>
                    <el-table-column prop="chantier" label="CHANTIER" align="center"></el-table-column>
                    <el-table-column prop="chefChantier" label="CHEF CHANTIER"></el-table-column>
                    <el-table-column prop="idwork" label="WORKLOG ID" align="center"></el-table-column>
                    <el-table-column prop="libelle" label="LIBELLE" align="center"></el-table-column>
                    <!-- <el-table-column prop="description" label="DESCRISPTION" ></el-table-column> -->
                    <el-table-column prop="enregistrer" label="ENREGISTRER PAR" align="center"></el-table-column>
                    <el-table-column prop="nbretaches" label="ACTIVITES" align="center"></el-table-column>
                    <!-- <el-table-column prop="enregistrer" label="ACTIVITES EN COURS" ></el-table-column> -->
                    <el-table-column prop="dateAdd" label="CREER" align="center"></el-table-column>\
                    <!-- <el-table-column prop="dateModification" label="MODIFIER" > </el-table-column>  -->
                    <el-table-column
                      align="center"
                      prop="statutworklog"
                      label="STATUT WORKLOGS"
                      fixed="right"
                    >
                      <template slot-scope="scope">
                        <el-tag
                          v-if="scope.row.statutworklog == 'Terminé'"
                          type="success"
                        >{{scope.row.statutworklog}}</el-tag>
                        <el-tag
                          v-if="scope.row.statutworklog == 'En cours'"
                          type="warning"
                        >{{scope.row.statutworklog}}</el-tag>
                        <el-tag
                          v-if="scope.row.statutworklog == 'Aucune activitée'"
                          type="info"
                        >{{scope.row.statutworklog}}</el-tag>
                      </template>
                    </el-table-column>
                    <el-table-column label="Action" align="center" fixed="right">
                      <template slot-scope="scope" >
                        <v-tooltip top>
                          <v-btn
                            slot="activator"
                            @click="modalDetail(scope.row)"
                            fab
                            dark
                            small
                            color="blue"
                          >
                            <v-icon dark>list</v-icon>
                          </v-btn>Détails...
                        </v-tooltip>
                      </template>
                    </el-table-column>
                  </data-tables>
                </v-flex>
              </v-layout>
              
            </v-card-text>
          </v-card>
        </v-layout>
      </v-flex>
    </v-layout>

    <!-- MODAL SHOW WORKLOG -->
    <v-dialog v-model="dialogShowWorklog" max-width="80%" :overlay="true" scrollable persistent>
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="blue">
          <v-toolbar-title>Détails du worklog {{worklogCourant.libelle}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogShowWorklog = false" dark>
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <el-row :gutter="20">
            <div class="grid-content bg-purple">
              <el-card class="box-card" style="background:#F9FAFC">
                <div class="text item">
                  <v-layout row wrap>
                    <v-flex md6>
                      <p>
                        <b>Libellé :</b>
                        {{worklogCourant.libelle}}
                      </p>
                      <p>
                        <b>Identifiant :</b>
                        {{worklogCourant.id}}
                      </p>
                      <p>
                        <b>Temps mis (Heure) :</b>
                        {{worklogCourant.tempsmis}}
                      </p>
                      <p>
                        <b>Description :</b>
                        {{worklogCourant.description}}
                      </p>
                    </v-flex>
                    <v-flex md6>
                      <p>
                        <b>Statut :</b>
                        {{worklogCourant.statutworklog}}
                      </p>
                      <p>
                        <b>Ajouter par :</b>
                        {{worklogCourant.enregistrer}}
                      </p>
                      <p>
                        <b>Date d'enregistrement :</b>
                        {{ worklogCourant.date }}
                      </p>
                      <p>
                        <b>Date de modification :</b>
                        {{ worklogCourant.dateModification}}
                      </p>
                      <p>
                        <v-avatar :tile="true" size="140px" height="120px" color="grey lighten-4">
                          <img :src="worklogCourant.urlImage" alt="avatar" />
                        </v-avatar>
                      </p>
                    </v-flex>
                  </v-layout>
                </div>
              </el-card>
              <br />
              <p>Liste des activitées</p>
              <el-card class="box-card" style="background:#F9FAFC">
                <div class="text item">
                  <v-layout row wrap>
                    <!-- <div class="elevation-3"> -->

                    <el-table :data="worklogCourant.taches" style="width: 100%">
                      <el-table-column prop="libelle" label="LIBELLE"></el-table-column>

                      <el-table-column prop="utilisateur" label="ENREGISTRER PAR"></el-table-column>
                      <el-table-column prop="dateCreation" label="DATE DE CREATION "></el-table-column>
                      <el-table-column prop="dateModification" label="MODIFIER LE"></el-table-column>
                      <el-table-column prop="date" label="DATE SYSTEME "></el-table-column>
                      <el-table-column prop="commentaire" label="COMMENTAIRE"></el-table-column>

                      <el-table-column prop="statut" label="STATUT"></el-table-column>
                    </el-table>
                    <!-- </div>  -->
                  </v-layout>
                </div>
              </el-card>

              <v-tooltip top>
                <v-btn
                  slot="activator"
                  icons
                  color="orange"
                  @click.stop="dialogShowWorklog = false"
                  dark
                >
                  Fermer
                  <v-icon right>close</v-icon>
                </v-btn>Fermer
              </v-tooltip>
              <!-- <v-tooltip top>
                  <v-btn slot="activator" icons color="primary" @click.stop="showDialogVersionEdit(worklogCourant)" dark>Mofifier <v-icon right>edit</v-icon></v-btn>
                  Modifier
              </v-tooltip>-->
            </div>
          </el-row>
        </v-card-text>

        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>
    <!-- END MODAL SHOW WORKLOG -->
  </div>
</template>

<script>
var echarts = require("echarts/lib/echarts");
import Loading from "@/components/Loading";

export default {
  components: { Loading },
  name: "Chantier_index",
  props: {
    listeChantiers: {
      type: Array
    }
  },

  data() {
    return {
      //data general
      loading: false,
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
      droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit")),
      loading: false,
      worklogCourant: {},
      listeWorklog: [],
      listProjet: [],
      listChantier: [],
      dialogShowWorklog: false,
      worklogTotal: 0,
      selectSearchChantierSuivi: "",
      selectTypeSearchProjet: "",
      totalActiviteEncours: 0,
      totalActivite: 0,
      totalActiviteTermine: 0,
      activiteeEnCours: 0,
      activiteeEnArret: 0,
      activiteeTermine: 0,
      selectTypeSearchSuivi: 1,
      typeSearch: [
        { text: "Chantier", value: 1 }
        // { text: "Par chantier", value: 2 }
      ]
    };
  },
  computed: {},
  watch: {
  },

  loadProduit() {
    let url = this.domaine + "product/product-list";
    this.$http.get(url).then(
      response => {
        if (response.body) {
          this.listProd = response.body;
        }
      },
      response => {}
    );
  },
  imprimeChaniter(idEtat = 0) {
    let url = this.domaine + "mission/impression/liste/" + idEtat;
    window.open(url);
  },
  methods: {
    loadWorklogChantier() {
      this.loading = true;
      let url = this.domaine + "worklogs/all/chantier/";

      this.$http.get(url).then(response => {
        this.loading = false;
        if (response.body) {
          this.listeWorklog = response.body.listeWorklog;
          this.worklogTotal = response.body.totalWorklogs;
          this.totalActivite = response.body.totalActivite;
          this.totalActiviteEncours = response.body.totalActiviteEncours;
          this.totalActiviteTermine = response.body.totalActiviteTermine;
        }

      });
    },
    loadChantierDetails(idChantier) {
      this.loading = true;
    //   this.docSelect = null;
      let url = this.domaine + "worklogs/details/"+idChantier;
      this.$http.get(url).then(
        response => {
          this.listeWorklog = response.body.listeWorklog;
          this.loading = false;
        },
        error => {
              this.loading = false;
            //   this.dialogWork = false;
              //this.resetForm('formWork');
              this.$message.error(
                "Une erreur est survenue lors de l'affichage des worklogs"
              );
            }
      );
    },
    modalDetail(item) {
      console.log(item);
      this.worklogCourant = item;
      this.dialogShowWorklog = true;
      console.log(this.dialogShowWorklog);
    },
     loadTravauxSuiviProjet(ligne) {
      this.loading = true;
      let url = this.domaine + "projet/"+ligne+"/index/chantier";
      this.$http.get(url).then(response => {
        if (response.body) {
          this.listChantier = response.body.chantier;
          this.loading = false;
        }
      });
    },
    loadProjet() {
      this.loading = true;
      let url = this.domaine + "projet/index";
      this.$http.get(url).then(response => {
        if (response.body) {
          this.listProjet = response.body.projet;
          this.loading = false;
        }
      });
    }
  },
  mounted() {
    // this.loading = true;
    this.loadProjet();
    this.loadWorklogChantier();
    // this.loadTravauxSuiviProjet();
    this.loading = false;
  }
};
</script>

<style>
</style>




// WEBPACK FOOTER //
// src/components/worklogs/Worklogs.vue